import styled from 'styled-components';
import { ModalActions } from '../../../../../components/KubitModal/KubitModalUI';
import { theme } from '../../../../../styles/theme';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 12px;
  margin-top: 8px;
`;

export const FormRow = styled.div<{ $enableSso: boolean }>`
  display: grid;
  grid-template-columns: ${({ $enableSso }) =>
    $enableSso
      ? '160px repeat(2, 120px) 1fr'
      : 'repeat(3, 160px) repeat(2, 120px) 1fr'};
  column-gap: 16px;
  align-items: start;
  width: 100%;
`;

export const FormHeader = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;

export const ActionsContainer = styled(ModalActions)`
  margin-right: 28px;
`;
